module.exports = __webpack_public_path__ + "static/media/order-faster-mobile.22c6c2b0.png";